import React, { useState, useEffect } from 'react';
import { Navigate } from 'react-router-dom';
import { supabase } from '../lib/supabase';

/**
 * AdminGuard
 * - ตรวจสอบว่า user ที่ login อยู่มี role = 'admin' หรือไม่
 * - ถ้าไม่ใช่ admin → redirect ไป /main-dashboard
 * - ถ้ายังไม่ได้ login → redirect ไป /login
 */
const AdminGuard = ({ children }) => {
  const [status, setStatus] = useState('checking'); // 'checking' | 'admin' | 'denied' | 'unauthenticated'

  useEffect(() => {
    const checkAdmin = async () => {
      try {
        const { data: { user } } = await supabase.auth.getUser();
        if (!user) {
          setStatus('unauthenticated');
          return;
        }

        const { data: profile } = await supabase
          .from('user_profiles')
          .select('role')
          .eq('id', user.id)
          .single();

        if (profile?.role === 'admin') {
          setStatus('admin');
        } else {
          setStatus('denied');
        }
      } catch (err) {
        console.error('AdminGuard check error:', err);
        setStatus('denied');
      }
    };

    checkAdmin();
  }, []);

  if (status === 'checking') return null;
  if (status === 'unauthenticated') return <Navigate to="/login" replace />;
  if (status === 'denied') return <Navigate to="/main-dashboard" replace />;

  return children;
};

export default AdminGuard;
